import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AppToaster } from "./components/ui/AppToaster";
import { App } from "./App";
import "./styles/globals.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // The dashboard reads live gateway state; refetching when the tab regains focus is the
      // behaviour users expect from an operations console.
      refetchOnWindowFocus: true,
      staleTime: 15_000,
      // A 401 is handled by the axios interceptor (refresh + retry). Retrying here as well
      // would just multiply failed requests once a session is genuinely gone.
      retry: 1,
    },
  },
});

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element not found");
}

createRoot(rootElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
      <AppToaster />
    </QueryClientProvider>
  </StrictMode>,
);
